import { TYPE_UK_ADDRESS } from '../../../utils/constants';
import { getAddresses } from './signatoriesPayload';

export const getUkAddressFromPostCode = state => {
  if (isInternationalAddress(state)) {
    return getInternationalAddress({ international: state });
  }
  const addressPayload = {
    uk_address: {
      organisation_name: state.organisation_name,
      address_prefix: state.address_prefix,
      house_number: state.house_number || '',
      house_name: state.house_name || '',
      street: state.street_name || state.street || state.address_line2,
      city: state.city,
      county: state.county,
      postal_code: state.postcode || state.postal_code
    }
  };
  if (state.id) {
    addressPayload.uk_address.address_reference = state.id;
  }
  return addressPayload;
};

export const getInternationalAddress = state => {
  return {
    international_address: {
      address_line1: state.international.address_line1,
      address_line2: state.international.address_line2 || '',
      address_line3: state.international.address_line3 || '',
      address_line4: state.international.address_line4 || '',
      country: state.international.CountryNameInt || state.country || state.international.country
    }
  };
};

export const getUkAddress = address => {
  const addressPayload = {
    uk_address: {
      organisation_name: address.organisation_name,
      address_prefix: address.local.FlatNumber || address.registerFlatNumber,
      house_number: address.local.BuildingNumber,
      house_name: address.local.HouseName,
      street: address.local.StreetName || address.local.addressline2,
      city: address.local.CityName,
      county: address.local.county,
      postal_code: address.local.postcode || address.postal_code
    }
  };
  return addressPayload;
};

export const getUkAddressFromCase = data => {
  const ukAddress = data.uk_address;
  if (ukAddress) {
    data.uk_address = {
      organisation_name: ukAddress.organisation_name || '',
      address_prefix: ukAddress.address_prefix,
      house_number: ukAddress.house_number || '',
      house_name: ukAddress.house_name || '',
      street: ukAddress.street,
      city: ukAddress.city,
      county: ukAddress.county,
      postal_code: ukAddress.postal_code
    };
    if (ukAddress.address_reference) {
      data.uk_address.address_reference = ukAddress.address_reference;
    }
  }
  return data;
};

export const mapSelectedAddresses = (officerData, state, currentOfficerNumber, addresses) => {
  const addressList = addresses
    ? addresses
    : getAddresses(officerData, state, currentOfficerNumber);
  addressList.forEach((element, index) => {
    const ukAddress = `${TYPE_UK_ADDRESS}${index > 0 ? index : ''}`;
    officerData[ukAddress] = officerData[ukAddress] ? officerData[ukAddress] : {};
    officerData[ukAddress].givenAddress = element.uk_address
      ? element.uk_address
      : element.international_address;
  });
  return officerData;
};

const isInternationalAddress = address => {
  const keys = Object.keys(address);
  return keys.every((v, i) => {
    if (i < keys.length - 1) {
      return v === `address_line${i + 1}`;
    }
    return v === 'country';
  });
};
